// Provisional wording; change here only.
const AUTHOR = 'International AI in Medicine Education Working Group'
const PUBLISHER = 'T-CAIREM'
const CONTAINER = 'T-CAIREM AI Learning Hub: Living Glossary'

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const MLA_MONTHS = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.']

const pad = (n) => String(n).padStart(2, '0')

// shortcut: LaTeX escaping covers the specials plus ~ and ^, not full Unicode; upgrade if non-ASCII terms render badly in BibTeX
const bibEscape = (s) => s.replace(/[\\{}&%$#_~^]/g, (c) => {
    if (c === '\\') return '\\textbackslash{}'
    if (c === '~') return '\\textasciitilde{}'
    if (c === '^') return '\\textasciicircum{}'
    return `\\${c}`
})

export const termCitations = ({ id, term, updated }, accessed = new Date()) => {
    const url = `${window.location.origin}/terminology/${id}`
    const u = new Date(updated)
    const [uy, um, ud] = [u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()]
    const [ay, am, ad] = [accessed.getFullYear(), accessed.getMonth(), accessed.getDate()]

    return {
        apa: `${AUTHOR}. (${uy}, ${MONTHS[um]} ${ud}). ${term}. In ${CONTAINER}. ${PUBLISHER}. Retrieved ${MONTHS[am]} ${ad}, ${ay}, from ${url}`,
        mla: `${AUTHOR}. "${term}." ${CONTAINER}, ${PUBLISHER}, ${ud} ${MLA_MONTHS[um]} ${uy}, ${url}. Accessed ${ad} ${MLA_MONTHS[am]} ${ay}.`,
        bibtex: [
            `@misc{tcairem_glossary_${id},`,
            `  author = {{${AUTHOR}}},`,
            `  title = {${bibEscape(term)}},`,
            `  publisher = {${PUBLISHER}},`,
            `  year = {${uy}},`,
            `  month = {${MONTHS[um].slice(0, 3).toLowerCase()}},`,
            `  howpublished = {\\url{${url}}},`,
            `  note = {${CONTAINER}. Accessed ${ay}-${pad(am + 1)}-${pad(ad)}}`,
            '}',
        ].join('\n'),
        ris: [
            'TY  - DICT',
            `AU  - ${AUTHOR}`,
            `TI  - ${term}`,
            `PB  - ${PUBLISHER}`,
            `T2  - ${CONTAINER}`,
            `PY  - ${uy}`,
            `DA  - ${uy}/${pad(um + 1)}/${pad(ud)}`,
            `UR  - ${url}`,
            `Y2  - ${ay}/${pad(am + 1)}/${pad(ad)}`,
            'ER  - ',
            '',
        ].join('\r\n'),
    }
}
